import { render } from "./DataReplaceConfirm.vue?vue&type=template&id=51015dea&scoped=true"
import script from "./DataReplaceConfirm.vue?vue&type=script&lang=js"
export * from "./DataReplaceConfirm.vue?vue&type=script&lang=js"

import "./DataReplaceConfirm.vue?vue&type=style&index=0&id=51015dea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51015dea"]])

export default __exports__